import config from './package.json';
import { ModuleConfig } from '../../types/configTypes';
import myPrivilegesContainer from './containers/MyPrivilegesContainer';
import myPrivilegesContainerDetails from './containers/MyPrivilegesDetailsContainer';
import myPrivilegesSaga from '../../modules/myPrivileges/sagas';
import myPrivilegesReducers from '../../modules/myPrivileges/reducers';
import { t } from '../../locales';
import { EMMA_MY_PRIVILEGES_MODULE_NAME } from '../../constants/constants';

export default {
  config,
  routes: {
    '': {
      exact: true,
      // Moved to lazy loading config because it register lazy route instead of this one now.
      // sidebarItem: {
      //   label: t('MYPRIVILEGES_LABEL'),
      //   iconDefault: `/assets/images/myprivileges.svg`,
      //   iconSelected: `/assets/images/myprivileges-selected.svg`,
      // },
      container: myPrivilegesContainer,
      moduleName: EMMA_MY_PRIVILEGES_MODULE_NAME,
    },
    '/seeall': {
      exact: true,
      container: myPrivilegesContainer,
    },
    '/:cardViewId': {
      exact: true,
      container: myPrivilegesContainerDetails,
    },
  },
  reducers: {
    myPrivileges: {
      reducer: myPrivilegesReducers,
    },
  },
  sagas: [myPrivilegesSaga],
} as ModuleConfig;
